<template>
  <md-autocomplete
    v-model="item"
    :md-options="items"
    @md-changed="getItems"
    @md-opened="getItems"
  >
    <label>{{ label }}</label>
  </md-autocomplete>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: ['label', 'options', 'val'],
  data: () => ({
    value: '',
    items: ['x']
  }),
  computed: {
    item: {
      get: function() {
        return this.value
      },
      set: function(newValue) {
        this.value = newValue
        this.$emit('updateValue', newValue)
      }
    }
  },
  watch: {
    val() {
      this.value = this.val
    }
  },

  mounted() {
    if (this.val !== undefined) {
      console.log({ valOnCreated: this.val })
      this.value = this.val
    }
  },
  methods: {
    getItems(searchTerm) {
      this.items = new Promise(resolve => {
        if (!searchTerm) {
          resolve(this.options.map(x => x.value))
        } else {
          const term = searchTerm.toLowerCase()
          this.items = this.options
            .filter(({ value }) => {
              return value.toLowerCase().includes(term)
            })
            .map(x => x.value)
          resolve(this.items)
        }
      })
    }

    // getSelected() {
    //  this.$emit("updateValue", this.value);
    // }
  }
}
</script>
